import type { BoxProps } from '@mui/material';

import { Box, Link } from '@mui/material';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import LogoLargeImg from 'src/legacy/assets/images/logo-large.png';
import LogoImg from 'src/legacy/assets/images/logo.png';

// ----------------------------------------------------------------------

export interface LogoProps extends BoxProps {
  disabledLink?: boolean;
  isMini?: boolean;
}

const Logo = forwardRef<HTMLDivElement, LogoProps>(
  ({ disabledLink = false, isMini = false, sx, ...other }, ref) => {
    const logo = (
      <Box
        component="div"
        ref={ref}
        sx={{
          display: 'inline-flex',
          height: 40,
          width: 40,
          ...sx,
        }}
        {...other}
      >
        <img alt="logo" src={LogoImg} />
      </Box>
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} sx={{ display: 'contents' }} to="/">
        <Box
          component="div"
          ref={ref}
          sx={{
            display: 'flex',
            height: '48px',
            justifyContent: 'center',
            width: '100%',
            ...sx,
          }}
          {...other}
        >
          <img
            alt="logo"
            src={isMini ? LogoImg : LogoLargeImg}
            style={{ height: '100%', width: 'auto' }}
          />
        </Box>
      </Link>
    );
  }
);

Logo.displayName = 'Logo';

export default Logo;
